JuiceProgramModel = require './models/juice_program'
JuiceProgramView = require './views/juice_program'

JuiceProgram =
  init: ({buyButton}, done = -> ) ->
    return unless buyButton.JuiceProgramInfo?.isJuiceProgramEnabled
    juiceModel = new JuiceProgramModel buyButton.JuiceProgramInfo
    juiceView = new JuiceProgramView model: juiceModel

    juiceView.render()
    done()

module.exports = JuiceProgram
